import { render, staticRenderFns } from "./HostileTakeOverNotificationComponent.vue?vue&type=template&id=217061bf&"
import script from "./HostileTakeOverNotificationComponent.vue?vue&type=script&lang=ts&"
export * from "./HostileTakeOverNotificationComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports